import { partnerAuth, partnerGuest } from '@/middleware';
import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    path: '/partner',
    component: () => import('@/layouts/PublicLayout.vue'),
    children: [
      {
        path: 'login',
        name: 'partner.login',
        beforeEnter: partnerGuest,
        component: () => import('@/pages/partner/PartnerLoginPage.vue'),
        meta: {
          title: 'Partner Login',
        },
      },
      {
        path: '',
        name: 'partner.dashboard',
        beforeEnter: partnerAuth,
        component: () => import('@/pages/partner/PartnerDashboardPage.vue'),
        meta: {
          title: 'Partner Dashboard',
        },
      },
    ],
  },
];

export default routes;
